import React from "react";
import { Box } from "@chakra-ui/react";
import { fileApplication } from "../../../utils/fileApplication";

// import UnknownImage from "../../../assets/images/icons/unkown.svg";
import AtsPdfViewer from "./AtsPdfViewer";
import AtsDocViewer from "./AtsDocViewer";
import StreamSidePanel from "./StreamSidePanel";

interface StreamModalProps {
  filename?: string;
  fileUrl?: string;
  data?: {
    subject: string;
    body: string;
    to: string;
    cc: string;
    bcc: string;
    recipient_name: string;
    submitted_at: string;
  };
  setResumeUrl?: any;
  html?: any;
  pdfHeight: any;
  docHeight: any;
  type?: string | null;
  resumeId?: string | null;
}

export default function StreamAttachmentComponent({
  filename,
  fileUrl,
  data,
  setResumeUrl,
  pdfHeight,
  docHeight = 700,
  type,
  resumeId,
}: StreamModalProps) {
  const StreamComponent = () => {
    if (filename) {
      switch (fileApplication(filename)) {
        case "doc":
          const doc = [{ uri: fileUrl, fileType: "doc" }];
          return (
            <Box
              style={{
                display: "flex",
                alignItems: "flex-start",
                width: "100%",
                gap: "10px",
              }}
            >
              <Box style={{ flex: 1, backgroundColor: "#FFFFFF" }}>
                <AtsDocViewer
                  docUrl={fileUrl}
                  documents={doc}
                  setResumeUrl={setResumeUrl}
                  height={docHeight}
                />
              </Box>
              <StreamSidePanel type={type} resumeId={resumeId} data={data} />
            </Box>
          );
        case "docx":
          const docx = [{ uri: fileUrl, fileType: "docx" }];
          return (
            <Box
              style={{
                display: "flex",
                alignItems: "flex-start",
                width: "100%",
                gap: "10px",
              }}
            >
              <Box style={{ flex: 1, backgroundColor: "#FFFFFF" }}>
                <AtsDocViewer
                  docUrl={fileUrl}
                  documents={docx}
                  setResumeUrl={setResumeUrl}
                  height={docHeight}
                />
              </Box>
              <StreamSidePanel type={type} resumeId={resumeId} data={data} />
            </Box>
          );
        case "pdf":
          return (
            <Box
              style={{
                display: "flex",
                alignItems: "flex-start",
                width: "100%",
                gap: "10px",
              }}
            >
              <Box style={{ flex: 1, backgroundColor: "#FFFFFF" }}>
                <AtsPdfViewer
                  pdfUrl={fileUrl}
                  setResumeUrl={setResumeUrl}
                  height={pdfHeight}
                />
              </Box>
              <StreamSidePanel type={type} resumeId={resumeId} data={data} />
            </Box>
          );

        default:
          return (
            <Box
              style={{
                display: "flex",
                alignItems: "flex-start",
                width: "100%",
                gap: "10px",
              }}
            >
              <StreamSidePanel type={type} resumeId={resumeId} data={data} />
            </Box>
          );
      }
    }
  };

  return (
    <Box
      style={{
        width: !type && !resumeId ? "900px" : "100%",
        margin: "auto",
        padding: "8px 16px",
        textAlign: "center",
      }}
    >
      <StreamComponent />
    </Box>
  );
}
